export const US_PHONE_MASK = '+1 (999) 999-9999';

const TEN_DIGITS = /^\d{10}$/;

export function phoneToDigits(value) {
  return (value ?? '').replace(/\D/g, '').slice(-10);
}

export function digitsToPhone(digits) {
  return digits ? `+1${digits}` : null;
}

export function isValidPhoneDigits(digits) {
  return TEN_DIGITS.test(digits ?? '');
}
